import { caTypes, caUtils } from '@mca/contentapi-js';
import * as logger from '../utils/logger';
import { toMilliSeconds, toSeconds } from './seek';
import { addEventBatch } from './gvp';
import { getQuality } from '../utils/medias';
import { streamType } from '../constants';

const log = logger.create('BI');
const playerManager = cast.framework.CastReceiverContext.getInstance().getPlayerManager();
const EVENTS_LIMIT = 10;
let events = [],
  sendTimeout = null,
  title;

/**
 * Adds BI event to list.
 * @param {Object} contentInfo VoD or live content.
 * @param {string} eventType Player event.
 * @param {Object} extraParams Contains language for AUDIO and SUBTITLE events.
 */
export function addEvent(contentInfo, eventType, extraParams) {
  const biEvent = getEvent(contentInfo);
  Object.assign(biEvent.Data, extraParams);
  biEvent.Data.EVENTTYPE = eventType;
  events.push(biEvent);
  log.info('Add BI event', biEvent);
  checkSend();
}

/**
 * Sends BI event batch.
 */
export function sendEvents() {
  if (events.length > 0) {
    try {
      addEventBatch(JSON.stringify(events));
      log.info('Add event batch', events);
      clearTimeout(sendTimeout);
      sendTimeout = null;
      events = [];
    } catch (e) {
      log.error('Event batch failed');
    }
  }
}

/**
 * Creates BI data depending on content type.
 * @param {Object} contentInfo VoD or live content.
 */
function getEvent(contentInfo) {
  let data;
  try {
    data =
      contentInfo.type === streamType.live
        ? getLiveData(contentInfo)
        : contentInfo.type === streamType.vod
        ? getVodData(contentInfo)
        : getRecordingData(contentInfo);
  } catch {
    data = {};
  }
  return {
    Event: contentInfo.type === streamType.live ? 'MobileLiveLogPlayback' : 'MobileVODLogPlayback',
    Data: data,
    Timestamp: Math.floor(toSeconds(Date.now()))
  };
}

/**
 * Creates BI VoD data.
 * @param {Object} contentInfo VoD info.
 */
function getVodData({ id, medias }) {
  return {
    EVENTTYPE: '',
    CONTENTID: caUtils.toPid(caTypes.CONTENT_TYPES.MOVIE, id),
    MEDIAID: medias[0].mediaId,
    INSTANTPLAYBACK: Math.floor(playerManager.getCurrentTimeSec())
  };
}

/**
 * Creates BI live data.
 * @param {Object} contentInfo Live info.
 */
function getLiveData({ liveSchedule, liveChannel, medias }) {
  return {
    EVENTTYPE: '',
    CHANNELNAME: liveChannel.title,
    CHANNELCALLLETER: liveChannel.callLetter,
    CHANNELID: caUtils.toPid(caTypes.CONTENT_TYPES.LIVE_CHANNEL, liveChannel.id),
    PROGRAMID: liveSchedule.pid,
    PROGRAMNAME: title,
    LIVESTREAMID: medias[0].mediaId,
    LIVESTREAMQUALITYNAME: getQuality(medias[0].quality)
  };
}

/**
 * Creates BI recording data.
 * @param {Object} contentInfo Recording info.
 */
function getRecordingData({ id }) {
  return {
    EVENTTYPE: '',
    CONTENTID: caUtils.toPid(caTypes.CONTENT_TYPES.RECORDING, id),
    INSTANTPLAYBACK: Math.floor(playerManager.getCurrentTimeSec())
  };
}

/**
 * Checks if there are enough events listed.
 */
function checkSend() {
  if (events.length >= EVENTS_LIMIT) {
    sendEvents();
  } else if (!sendTimeout) {
    sendTimeout = setTimeout(sendEvents, toMilliSeconds(EVENTS_LIMIT * 60));
  }
}

/**
 * Sets current content's title.
 * @param {string} contentTitle Title.
 */
export function setTitle(contentTitle) {
  title = contentTitle;
}

/**
 * Gets current content's title.
 * @returns {string} Title.
 */
export function getTitle() {
  return title;
}
